export default __webpack_public_path__ + "static/media/gallery_04.687de8e1.jpg";